module.exports = __webpack_public_path__ + "static/media/logo.5a29392c.png";